import { IOExtension } from 'z3k-config';
import { getDeviceSpecV2 } from './z3k-feature-flags';
import { parsePhysicalIO } from 'z3k-parser/lib';
import { IOExtensionType, } from 'z3k-parser/model/device-spec/type';
import { builtin_extension_specs, extension_specs, } from 'z3k-parser/model/device-spec/specs';
import { isDevelopment } from 'utils';
let builtin_server_spec = {};
let is_first_load_builtin = true;
function firstUpdateBuiltInServerSpec() {
    if (window._ui?.store && is_first_load_builtin) {
        is_first_load_builtin = false;
        builtin_server_spec =
            window._ui.store.getState()?.device_spec.builtin_spec || {};
        window._ui.store.subscribe(() => (builtin_server_spec =
            window._ui.store.getState()?.device_spec.builtin_spec || {}));
    }
}
function getBuiltinSpec(key) {
    //in dev use yaml from code, need reload build after changes!
    if (isDevelopment()) {
        return builtin_extension_specs[key];
    }
    return (builtin_server_spec?.[key] ??
        builtin_extension_specs[key]);
}
let extension_server_spec = {};
let is_first_load_extension = true;
function firstUpdateExtensionServerSpec() {
    if (window._ui?.store && is_first_load_extension) {
        is_first_load_extension = false;
        extension_server_spec =
            window._ui.store.getState()?.device_spec.extension_spec || {};
        window._ui.store.subscribe(() => (extension_server_spec =
            window._ui.store.getState()?.device_spec.extension_spec || {}));
    }
}
const convertIoExtensionSpecToType = {
    [IOExtension.Type.RADIO_RELAY]: 'RADIO_RELAY',
    [IOExtension.Type.CE_2]: 'CE_2',
    [IOExtension.Type.HUMIDITY_TEMP_SENSOR]: 'HUMIDITY_TEMP_SENSOR',
    [IOExtension.Type.TEMP_SENSOR]: 'TEMP_SENSOR',
    [IOExtension.Type.BUILTIN_BOARD]: 'BUILTIN_BOARD',
    [IOExtension.Type.ZE22]: 'ZE22',
    [IOExtension.Type.ZE44]: 'ZE44',
    [IOExtension.Type.ZE88]: 'ZE88',
    [IOExtension.Type.ZE8482]: 'ZE8482',
    [IOExtension.Type.HW_ext_board_ZE_03_SOCKETS]: 'ZE_03_SOCKETS',
    [IOExtension.Type.HW_ext_board_ZE_00_GATEWAY]: 'ZE_00_GATEWAY',
    [IOExtension.Type.ZE66]: 'ZE66',
};
function getExtensionSpec(type) {
    const key = convertIoExtensionSpecToType[type];
    //in dev use yaml from code, need reload build after changes!
    if (isDevelopment()) {
        return extension_specs[key];
    }
    return (extension_server_spec?.[key] ?? extension_specs[key]);
}
export function getIOExtensionSpec(ioExtType, io_ext_serial, device_spec) {
    firstUpdateBuiltInServerSpec();
    firstUpdateExtensionServerSpec();
    if (ioExtType) {
        if (ioExtType === IOExtension.Type.BUILTIN_BOARD) {
            return getBuiltinSpec(device_spec?.io.builtin_io_extensions.find(({ serial }) => serial === io_ext_serial)?.type ?? IOExtensionType.Sockets_03);
        }
        //@ts-ignore
        return getExtensionSpec(ioExtType);
    }
    return getExtensionSpec(IOExtension.Type.ZE66);
}
export function getIOExtensionSpecFromPhysicalInput(spec, z3k_config, physical_input_num) {
    if (!spec) {
        return null;
    }
    // для z3k_PRO надо смотреть на БР встроенный
    if (spec.io.builtin_io_extensions.length == 0) {
        return null;
    }
    const { block_id, input_number } = parsePhysicalIO(physical_input_num);
    if (block_id == null && input_number == null) {
        return null;
    }
    return getIOExtensionSpecByBlockId(spec, z3k_config, block_id);
}
export function getIOExtensionSpecByBlockId(spec, z3k_config, block_id) {
    if (!spec || block_id == null) {
        return null;
    }
    // для z3k_PRO надо смотреть на БР встроенный
    if (spec.io.builtin_io_extensions.length == 0) {
        return null;
    }
    const io_extension = IOExtension.get.byId(z3k_config, block_id);
    if (!io_extension) {
        return null;
    }
    return getIOExtensionSpec(io_extension.type, io_extension.serial, spec);
}
export function isPowerVoltageInput(z3k_config, physical_input_num) {
    const device_spec = getDeviceSpecV2(z3k_config.device?.name, z3k_config.device?.hardware);
    // Справедливо для приборов z3k!
    if (device_spec && physical_input_num == device_spec.io.power_voltage_input) {
        return true;
    }
    const { block_id, input_number } = parsePhysicalIO(physical_input_num);
    if (block_id == null && input_number == null) {
        return false;
    }
    // для z3k_PRO надо смотреть на БР встроенный
    const spec = getIOExtensionSpecFromPhysicalInput(device_spec, z3k_config, physical_input_num);
    if (spec) {
        return spec.power_voltage_input == input_number;
    }
    return false;
}
export function isBatteryVoltageInput(z3k_config, physical_input_num) {
    const device_spec = getDeviceSpecV2(z3k_config.device?.name, z3k_config.device?.hardware);
    // Справедливо для приборов z3k!
    if (device_spec && physical_input_num == device_spec.io.battery_voltage_input) {
        return true;
    }
    const { block_id, input_number } = parsePhysicalIO(physical_input_num);
    if (block_id == null && input_number == null) {
        return false;
    }
    // для z3k_PRO надо смотреть на БР встроенный
    const spec = getIOExtensionSpecFromPhysicalInput(device_spec, z3k_config, physical_input_num);
    if (spec) {
        return spec.battery_voltage_input == input_number;
    }
    return false;
}
